<ada-card
	#IconPropertiesCard
	id="IconPropertiesCard"
	verticalSpacing="Small"
	width="100%"
	[collapseEnabled]="true"
>
	<ada-text
		content="Icon Properties"
		data-container-selector="ada-card-header"
		id="IconPropertiesCardHeader"
	/>
	<ada-container
		data-container-selector="ada-card-body"
		horizontalSpacing="Medium"
		verticalSpacing="Medium"
		[colCount]="4"
		[padding]="defaultCardPadding"
	>
		@if ('IconID' | displayAuthoringProperty: editorClass : propertyConstructor.namespace) {
			<ada-authoring-property-label
				#IconIDLabel
				content="Icon"
				id="IconIDLabel"
				[isDisabled]="isDisabled"
				[isRequired]="true"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			/>

			<ada-object-list
				#IconObjectList
				data-testid="icon-properties-software-icon-list"
				id="IconObjectList"
				[isDisabled]="isDisabled"
				[isMultiselect]="false"
				[javaClassName]="softwareIconClassName"
				[objectIds]="currentPropertyObject?.IconID"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
				(objectIdsChange)="setObjectListOutput('IconID', $event)"
			/>
		}

		@if ('CompressedData' | displayAuthoringProperty: editorClass : propertyConstructor.namespace) {
			<ada-authoring-property-label
				#CompressedDataLabel
				id="CompressedDataLabel"
				[content]="'Compressed Data'"
				[isDisabled]="isDisabled"
				[isRequired]="true"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
			/>
			<ada-container
				verticalSpacing="Medium"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				@if (iconUrl$ | async) {
					<ada-image
						#IconPreview
						id="IconPreview"
						[source]="iconUrl$ | async"
					/>
				}

				<ada-file-uploader
					#FileUploader
					id="IconFileUploader"
					readAs="dataUrl"
					[accept]="['.ico']"
					[isDisabled]="isDisabled"
					[maxSize]="maxIconSize"
					[isPreloaded]="!!(iconUrl$ | async)"
					(fileChange)="setIconFile($event)"
				/>
			</ada-container>
		}
	</ada-container>
</ada-card>
